<template>
   <el-popover
	 		placement="top-start" 
			title="Channel Change History" 
			trigger="hover"
			@show="getChannelChangeHistory()"
			>
			<div v-if="!onload">
				<div v-if="!_gHlp.isEmpty(listChilds)">
					<p v-for="item in listChilds" :key="item.lead_id">
							<b>{{ item.channel.name }} - {{item.platform.name}}</b><br/>
							<small>Old Lead Id {{ item.lead_id }} | Created At {{ _gHlp.formatDate(item.created_at) }}</small>
					</p>
				</div>
				<div v-else>
					<small><i>No History</i></small>
				</div>
			</div>
			<div v-else>
				<small><i>load content...</i></small>
			</div>
			<!-- <p slot="reference" class="mb-0 top-line">{{ channel_name }} <i class="fas fa-star text-warning"></i></p> -->
			<p slot="reference" class="mb-0 top-line"><i class="fas fa-star text-warning"></i></p>
	</el-popover>
</template>
<script>
	import { Popover } from 'element-ui'
	import { useLeadStore } from '@/stores/leadStore'
	import { mapActions } from 'pinia'
  export default {
		props: ['lead_name','lead_contact_no','lead_created_at','channel_name'],
    name: 'channel-popover',
		components:{
			[Popover.name]: Popover
		},
    data() {
      return {
        listChilds: [],
				onload: false
      }
    },
		methods: {
        ...mapActions(useLeadStore, ['getPrevLeads']),
				async getChannelChangeHistory(){
					this.onload = true;
					this.listChilds = await this.getPrevLeads(this.lead_contact_no,this.lead_created_at);
					if(!_gHlp.isEmpty(this.listChilds)) this.listChilds.sort((a, b) => b.lead_id - a.lead_id)
					this.onload = false;
				}
		}

  }
</script>
